import { api } from "./api";

export const GetRequestStatusTenant = async (referenceid: number) => {
  try {
    const response = await api.get("/dropdown/v1/getrequeststatustenant", {
      params: { referenceid },
    });
    if (response.status === 200) return response.data;
    return undefined;
  } catch {
    return undefined;
  }
};

export const GetRequestTenant = async (
  tenantid: number,
  taskid: number,
  mallid: number,
  tenantrequestid: number,
  requeststatusid: number,
  number: number,
  page: number
) => {
  try {
    const response = await api.get("/tenant/v1/getrequesttenant", {
      params: {
        tenantid,
        taskid,
        mallid,
        tenantrequestid,
        requeststatusid,
        number,
        page,
      },
    });
    if (response.status === 200) return response.data;
    return undefined;
  } catch {
    return undefined;
  }
};

export const SaveRequestTenant = async (payload: Record<string, unknown>) => {
  try {
    const response = await api.post("/tenant/v1/saverequesttenant", payload);
    if (response.status === 200) return response.data;
    return undefined;
  } catch {
    return undefined;
  }
};